import React from 'react'
import './Consultancy.css'


const Consultancy = () => {

const phoneNumber = '+923286506281'; 

const handleCall = () => {
    window.location.href = `tel:${phoneNumber}`
}

  return (
    <div className='consultancy-main-container'>
<div className="consultancy-container">

<div className="consultancy-header">
    <h2>See what we offer 
        and how it works
    </h2>

    <p>Expert guidence - everything
        you need to explore
        and buy with confidence.</p>
</div>

<div className="consultancy-content">
    <section className='consultancy-content-left'>
        <h3>Property Section</h3>
        <p>Our expert team will provide you full guidence about the house you want to buy, rent or purchase. Our construction team will help you in builing your dream home. </p>
        <button onClick={handleCall}>Get Consultancy</button>
    </section>
    <section className='consultancy-content-right'>
        <img src="https://res.cloudinary.com/dggey8rb6/image/upload/v1777177644/Untitled_design_6_ql7jyx.jpg" alt="Consultancy" loading = "lazy" />
    </section>
</div>
</div>
    </div>
  )
}

export default Consultancy